// extracted by mini-css-extract-plugin
export default {"MiddleComp":"MiddleComp_MiddleComp__OFXbL"};